function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M13.9333 7.26664C13.9333 10.9485 10.9485 13.9333 7.26664 13.9333M13.9333 7.26664C13.9333 3.58474 10.9485 0.599976 7.26664 0.599976M13.9333 7.26664H0.599976M7.26664 13.9333C3.58474 13.9333 0.599976 10.9485 0.599976 7.26664M7.26664 13.9333C5.5548 12.1359 4.59998 9.74881 4.59998 7.26664C4.59998 4.78447 5.5548 2.39741 7.26664 0.599976M7.26664 13.9333C8.97849 12.1359 9.93331 9.74881 9.93331 7.26664C9.93331 4.78447 8.97849 2.39741 7.26664 0.599976M0.599976 7.26664C0.599976 3.58474 3.58474 0.599976 7.26664 0.599976",
  stroke: "#181A23",
  strokeWidth: 1.2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var SvgGlobeLight = function SvgGlobeLight(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgGlobeLight, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/globe_light.9db23ae3.svg";
export { ForwardRef as ReactComponent };